// Import Tailwind CSS
import "../styles/tailwind.css";

// Import custom SCSS styles
import "../scss/app.scss";

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

window.getCookie = function(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

document.querySelectorAll('.urgentCareJs').forEach((el, index) => {
    const facilityId = el.dataset.expressid;
    const facilityName = el.dataset.name;

    if (facilityId) {
        const apiUrl = `https://apps10.erexpress.com/erx-reservationform/api/firstavailable/${facilityId}`;
        const script = document.createElement('script');
        const callbackName = `urgentCareCallback_${index}_${Date.now()}`;

        window[callbackName] = function(data) {
            if (facilityName) {
                const targetElement = document.querySelector(`.${facilityName} .first`);
                if (targetElement) {
                    targetElement.innerHTML = data.reservationTime || '';
                }
            }
            document.head.removeChild(script);
            delete window[callbackName];
        };

        script.src = `${apiUrl}?callback=${callbackName}`;
        script.onerror = function() {
            console.error(`API call failed for facility ${facilityName}`);
            document.head.removeChild(script);
            delete window[callbackName];
        };

        document.head.appendChild(script);
    }
});

// Hot module replacement for development
if (import.meta.hot) {
    import.meta.hot.accept();
}
